import { render } from "./status_block.vue?vue&type=template&id=0480c588"
import script from "./status_block.vue?vue&type=script&lang=js"
export * from "./status_block.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__